import db from '@/firebase/init'
import moment from "moment";
import * as firebase from 'firebase';

export function modulgetRefDBWhere(collectionName, wherePropery, whereValue){
      let ref=db.collection(collectionName).where(wherePropery, '==', whereValue);
      return ref;
}

export function modulgetRefDB(collectionName, sortField){
      let ref=db.collection(collectionName).orderBy(sortField);
      return ref;
}

export function modulgetRefDBNoSort(collectionName){
  let ref=db.collection(collectionName);
  return ref;
}




// WEBPACK FOOTER //
// ./src/firebase/MainDBManager.js